__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__spPgwa__checkbox",
  "disabled": "checkbox-module-scss-module__spPgwa__disabled",
  "proxyInput": "checkbox-module-scss-module__spPgwa__proxyInput",
  "proxyLabel": "checkbox-module-scss-module__spPgwa__proxyLabel",
  "required": "checkbox-module-scss-module__spPgwa__required",
});
